import * as Scrivito from "scrivito";
import { Table } from "reactstrap";
import { intersection } from "lodash-es";
import I18n from "^/config/i18n";
import courseDetailsMapping from "../../utils/courseDetailsMapping";

const mergeAttributes = (customData, data = []) => {
  let output = [...data];
  if (customData && Array.isArray(customData)) {
    output = [...output, ...customData];
  } else if (customData) {
    output.push(customData);
  }
  return output;
};

const filtered = (course, terms) => {
  const degree =
    terms.degree &&
    terms.degree.filter((d) => (course.get("degree") || "").startsWith(d));
  const orientation =
    terms.orientation &&
    intersection(terms.orientation, course.get("orientation"));
  const location =
    terms.location &&
    terms.location.filter((d) => course.get("location").includes(d));
  const start = terms.start && intersection(terms.start, course.get("start"));
  const form = terms.form && intersection(terms.form, course.get("form"));

  return (
    (degree && degree.length === 0) ||
    (orientation && orientation.length === 0) ||
    (location && location.length === 0) ||
    (start && start.length === 0) ||
    (form && form.length === 0)
  );
};

const translateMultipleElements = (mapping, data = []) =>
  data.map((el) => mapping[el]);

const CourseFilterTable = ({ courses, terms, sortBy, setSortBy }) => {
  const mapping = courseDetailsMapping();
  const joinAttributes = (data, separator = " / ") => data.join(separator);

  const sortedCourses = courses.sort((first, second) => {
    const field = sortBy[0];
    const sortOrder = sortBy[1];
    const firstVal = first.get(field);
    const secondVal = second.get(field);

    const aValue = Array.isArray(firstVal)
      ? firstVal.join(",")
      : firstVal || "";
    const bValue = Array.isArray(secondVal)
      ? secondVal.join(",")
      : secondVal || "";

    return sortOrder === "asc"
      ? aValue.localeCompare(bValue)
      : bValue.localeCompare(aValue);
  });

  const sortedAndFiltered = sortedCourses.filter(
    (course) => !filtered(course, terms)
  );

  const headers = [
    ["title", I18n.t("CourseOver studies course")],
    ["degree", I18n.t("CourseOver degree")],
    ["orientation", I18n.t("CourseOver orientation")],
    ["form", I18n.t("CourseOver form")],
    ["lang", I18n.t("CourseOver language")],
    ["location", I18n.t("CourseOver location")],
    ["start", I18n.t("CourseOver start")],
  ];

  return (
    <div className="course-list">
      <Table className="responsive-table">
        <thead>
          <tr>
            {headers.map((head, index) => (
              <th
                key={index}
                className={`${
                  sortBy[0] === head[0] ? "--active" : "--inactive"
                } ${sortBy[1] === "asc" ? "--asc" : "--desc"}`}
                onClick={() => {
                  if (index !== 0) return;
                  setSortBy([
                    head[0],
                    sortBy[0] === head[0] && sortBy[1] === "asc"
                      ? "desc"
                      : "asc",
                  ]);
                }}
              >
                {head[1]}
                {index === 0 && (
                  <i
                    className={`las la-${
                      sortBy[0] === head[0] ? "angle-down" : "equals"
                    }`}
                  />
                )}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {[...sortedAndFiltered].map((course, index) => (
            <tr className="course-list__item" key={index}>
              <td>
                {
                  <Scrivito.LinkTag className="text-blue" to={course}>
                    {course.get("title")}
                  </Scrivito.LinkTag>
                }
              </td>
              <td title={I18n.t("CourseOver degree")}>
                {mapping[course.get("degree")]}
              </td>
              <td
                className="course-list__item--orientation"
                title={I18n.t("CourseOver orientation")}
              >
                {course.get("orientation").map((item) => (
                  <span className="me-1" key={course.id() + item}>
                    {mapping[item]}
                  </span>
                ))}
              </td>
              <td title={I18n.t("CourseOver form")}>
                {joinAttributes(
                  translateMultipleElements(mapping, course.get("form"))
                )}
              </td>
              <td title={I18n.t("CourseOver language")}>
                {joinAttributes(
                  translateMultipleElements(mapping, course.get("lang")),
                  " & "
                )}
              </td>
              <td title={I18n.t("CourseOver location")}>
                {joinAttributes(
                  mergeAttributes(
                    course.get("customLocation"),
                    translateMultipleElements(mapping, course.get("location"))
                  )
                )}
              </td>
              <td title={I18n.t("CourseOver start")}>
                {joinAttributes(
                  mergeAttributes(
                    course.get("customStart"),
                    translateMultipleElements(mapping, course.get("start"))
                  )
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};
export default Scrivito.connect(CourseFilterTable);
